import React, { useState } from 'react'
import ConfigTable from './ConfigTable'

function ConfigTableParent({link, refresh, setLoading,filterData,parentOrCat,clickLink}) {
    return (<ConfigTable filterData={filterData} link={link} refresh={refresh} setLoading={setLoading} parentOrCat={parentOrCat} clickLink={clickLink}/>)
}
export default ConfigTableParent